import paymentMethodsConstants from '../constants/payment-methods-constants';
import constants from '../../../../common/constants';

import bankImage from '../images/bank-method.png';
import creditCardImage from '../images/credit-card-method.png';
import defaultPaymentMethodImage from '../images/payment-method.png';

class PaymentMethodsHelpers {
  static filterPaymentMethodStatuses(status) {
    const objectKeys = Object.keys(paymentMethodsConstants.statuses);
    let result = status;

    objectKeys.forEach(key => {
      if (paymentMethodsConstants.statuses[key].code === status) {
        result = paymentMethodsConstants.statuses[key].text;
      }
    });

    return result;
  }

  static getPaymentMethodImage(paymentMethodTypeId) {
    switch (paymentMethodTypeId) {
      case constants.payment_method_types.bank.id:
        return bankImage;
      case constants.payment_method_types.credit_card.id:
        return creditCardImage;
      default:
        return defaultPaymentMethodImage;
    }
  }

  static getPaymentMethodStatus(status, isStatusTitle) {
    if (status === paymentMethodsConstants.statuses.approved.code) {
      return isStatusTitle ? 'PAYMENT_METHOD.READY_FOR_WITHDRAWALS' : `PAYMENT_METHOD.STATUS_${this.filterPaymentMethodStatuses(status).toUpperCase()}`;
    }

    return isStatusTitle ? 'PAYMENT_METHOD.ACTION_REQUIRED' : `PAYMENT_METHOD.STATUS_${this.filterPaymentMethodStatuses(status).toUpperCase()}`;
  }

  static formatKey(key) {
    return key ? key.replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase()) : '';
  }
}

export default PaymentMethodsHelpers;



// WEBPACK FOOTER //
// ./src/app/main/payment-methods/helpers/payment-methods-helpers.js